import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './PullToRefresh.module.css';

const THRESHOLD = 60;
const MAX_PULL = 100;

function getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

class PullToRefresh extends Component {
  static propTypes = {
    onRefresh: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      pullDistance: 0,
      refreshing: false,
    };
    this.startY = 0;
    this.pulling = false;
    this.containerRef = React.createRef();
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
  }

  componentDidMount() {
    var el = this.containerRef.current;
    if (el) {
      el.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      el.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      el.addEventListener('touchend', this.handleTouchEnd, { passive: true });
    }
  }

  componentWillUnmount() {
    var el = this.containerRef.current;
    if (el) {
      el.removeEventListener('touchstart', this.handleTouchStart);
      el.removeEventListener('touchmove', this.handleTouchMove);
      el.removeEventListener('touchend', this.handleTouchEnd);
    }
  }

  handleTouchStart(e) {
    if (getScrollTop() <= 0 && !this.state.refreshing) {
      this.startY = e.touches[0].clientY;
      this.pulling = true;
    }
  }

  handleTouchMove(e) {
    if (!this.pulling) return;

    var currentY = e.touches[0].clientY;
    var distance = currentY - this.startY;

    if (distance > 0 && getScrollTop() <= 0) {
      e.preventDefault();
      var pullDistance = Math.min(distance * 0.4, MAX_PULL);
      this.setState({ pullDistance: pullDistance });
    } else {
      this.pulling = false;
      this.setState({ pullDistance: 0 });
    }
  }

  handleTouchEnd() {
    if (!this.pulling) return;
    this.pulling = false;

    var pullDistance = this.state.pullDistance;
    var onRefresh = this.props.onRefresh;

    if (pullDistance >= THRESHOLD) {
      this.setState({ refreshing: true, pullDistance: THRESHOLD });
      Promise.resolve(onRefresh()).then(function() {
        this.setState({ refreshing: false, pullDistance: 0 });
      }.bind(this));
    } else {
      this.setState({ pullDistance: 0 });
    }
  }

  render() {
    var children = this.props.children;
    var pullDistance = this.state.pullDistance;
    var refreshing = this.state.refreshing;

    return (
      <div ref={this.containerRef} className={styles.container}>
        <div
          className={styles.indicator}
          style={{ height: pullDistance > 0 ? pullDistance : 0 }}
        >
          <div className={styles.spinner + (refreshing ? ' ' + styles.spinning : '')}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                opacity: Math.min(pullDistance / THRESHOLD, 1),
                transform: 'rotate(' + ((pullDistance / THRESHOLD) * 360) + 'deg)',
              }}
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
          </div>
        </div>
        {children}
      </div>
    );
  }
}

export default PullToRefresh;
